export default __webpack_public_path__ + "static/dev3-100548d4e0e56c44898c9b58f4cc12ed.svg";